/* eslint-disable react/jsx-no-undef */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable no-lonely-if */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable max-lines */

import { countryList } from 'constants';
import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { Form, Formik } from 'formik';
import { toast } from 'sonner';
import * as Yup from 'yup';

import { PhoneInput, RadioSelect } from 'components/FormComponents';
import {
  DropDownSelect,
  FloatingInput,
  Input,
  Upload,
} from 'components/FormikInputs';
import GenericErrorPopup from 'components/GenericError';
import { DateOfBirth, DoB } from 'components/GlobalLogin/styles';
import CheckedIcon from 'components/Images/Checked';
import DownloadWithoutCircle from 'components/Images/DownloadWithoutCircle';
import Exclamation from 'components/Images/Exclamation';
import FileIcon from 'components/Images/FileIcon';
import InfoIcon from 'components/Images/InfoIcon';
import Loader from 'components/Loader';
import { Popup } from 'components/Popup';
import DataModal from 'pages/Home/WBPSteps/DataModal';
import { AccountContext } from 'providers/accountProvider';
import { get, post } from 'lib/api';
import {
  booleanOptions,
  calculateStringMatchScore,
  checkOverseasUser,
  contractTypeOptions,
  extractDocuments,
  getNameFromUrl,
  getTokenAndUid,
  handleEventLog,
  handleFlutterCallbacks,
  handleNotionOrExternalLink,
  handlePageLoadEventLog,
  wordCount,
} from 'lib/utils';
import { Box, Text } from 'designSystem';

import {
  AgreeCTA,
  CheckBox,
  CheckSampleBtn,
  ConfirmAndSubmit,
  Container,
  DownloadButton,
  DownloadPdfButton,
  ExtraNote,
  FileContainer,
  FileDetailsDiv,
  FileIconDiv,
  FileName,
  FileNameDiv,
  FilePlaceHolder,
  FlexContainer,
  HelpText,
  HoverActions,
  HR,
  InlineInfoText,
  InputContainer,
  InvalidDetailsDiv,
  LinearProgress,
  ProgressBar,
  ProgressDiv,
  ProgressPercent,
  RadioIcon,
  RightCrossIcon,
  SaveBtn,
  SaveButton,
  SectionHeading,
  StyledCrossIcon,
  SubSectionTitle,
  UploadButton,
  UploadLabel,
} from '../Home/WBPSteps/styles';

export const FileUploadComponent = ({
  readOnly,
  isLoading,
  progress,
  imageUrl,
  placeholder,
  handleReUpload = () => null,
  title,
  hasError,
  cancelRequest,
  privateDownload,
}) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handlePrivateDownload = () => {
    if (!imageUrl) return;
    const extension = imageUrl.split('.').pop();
    get('/upload/user_docs', {
      params: {
        base_url: imageUrl,
        is_novel: 1,
      },
    }).then((response) => {
      const { signed_url: link } = response;
      const hiddenElement = document.createElement('a');
      hiddenElement.href = link;
      hiddenElement.target = '_blank';
      hiddenElement.download = 'doc.' + extension;
      hiddenElement.click();
      setIsProcessing(false);
    });
  };
  return (
    <>
      {!imageUrl && !isLoading && (
        <FileContainer hasError={hasError}>
          {/* <UploadIcon /> */}
          {placeholder && <FilePlaceHolder>{placeholder}</FilePlaceHolder>}
        </FileContainer>
      )}
      {isLoading && (
        <ProgressDiv>
          <LinearProgress>
            <ProgressBar value={progress >= 100 ? 100 : progress} />
          </LinearProgress>
          <ProgressPercent>
            {(progress >= 100 ? '100' : progress.toFixed(0)) + '% Uploaded'}
          </ProgressPercent>
          <StyledCrossIcon onClick={cancelRequest} />
        </ProgressDiv>
      )}
      {imageUrl && !isLoading && (
        <FileNameDiv>
          <FileIconDiv>
            <FileIcon />
          </FileIconDiv>
          <FileDetailsDiv>
            <FileName>{getNameFromUrl(imageUrl, title)}</FileName>
          </FileDetailsDiv>
          <HoverActions>
            {!privateDownload && (
              <DownloadButton href={imageUrl} download type="button">
                Download
              </DownloadButton>
            )}
            {privateDownload && (
              <DownloadPdfButton onClick={handlePrivateDownload} type="button">
                {isProcessing ? 'Downloading...' : 'Download'}
              </DownloadPdfButton>
            )}
            {!readOnly && (
              <UploadButton type="button" onClick={handleReUpload}>
                Upload
              </UploadButton>
            )}
          </HoverActions>
        </FileNameDiv>
      )}
    </>
  );
};

const WbpForm = ({
  setCurrentStep,
  book,
  handleContractDetails,
  isNovelContract = false,
  showTerms,
  id,
  handleGenerateContract,
  resetSteps,
}) => {
  const book_name = book?.book_title;
  const book_language = book?.language;
  const [data, setData] = useState(null);
  const [guardianData, setGuardianData] = useState(null);
  const [authorBankData, updateAuthorBankData] = useState(null);
  const [rowData, setRowData] = useState(null);
  const [addressData, setAddressData] = useState(null);
  const [novelData, setNovelData] = useState(null);
  const [isAgreed, setIsAgreed] = useState(false);
  const [focusFields, setFocusFields] = useState({ email: true });
  const [govtUrl, setGovtUrl] = useState({});
  const [w8Url, setW8] = useState({});
  const [w9Url, setW9] = useState({});
  const [panCardUrl, setPanCardUrl] = useState({});
  const [ssnOrEinUrl, setSsnOrEinUrl] = useState({});
  const [taxIdUrl, setTaxIdUrl] = useState({});
  const [cancelCheque, setCancelCheque] = useState({});
  // TODO: Remove or handle before localisation
  const { user, isUgcUser, isHindiUgcUser, isWriterLocalisation } =
    useContext(AccountContext);
  const wbpInvite = book?.wbp_invite_only?.eligible;
  const isUserIndian = !checkOverseasUser(user);
  const isSeries = book?.is_novel === 2;
  const [apiError, toggleApiError] = useState({
    show: false,
    title: '',
    message: '',
  });

  const [showSampleData, setShowSampleData] = useState(false);
  const [sampleData, setSampleData] = useState({ url: '', heading: '' });
  const [optionChosenAfterNameMismatch, updateOptionChosenAfterNameMismatch] =
    useState('');
  const [nameMismatchPopup, toggleNameMismatchPopup] = useState(false);
  const [guardianPhoneNo, updateGuardianPhoneNo] = useState('');
  const [guardianPhoneErr, setGuardianPhoneErr] = useState('');
  const saveButtonRef = useRef(null);
  const [isContentAvailable, setIsContentAvailable] = useState();
  const [enteredIntoAgreement, setEnteredIntoAgreement] = useState();
  const [showModal, setShowModal] = useState(false);
  const [isExclusive, setIsExclusive] = useState();
  const [dob, setDoB] = useState(null);
  const [infoActive, setInfoActive] = useState(false);
  const { uid } = getTokenAndUid();

  const englishProgramBook = [
    'series_ALL_english_v1',
    'writer_benefit_v3_us',
  ].includes(book?.program_type);

  const nonEnglishProgramBook = [
    'novel_ALL_hindi_v1',
    'novel_IN_tamil_v1',
    'series_IN_hindi_v1',
    'writer_benefit_v3',
    'writer_benefit_series',
  ].includes(book?.program_type);

  const isLocalisedEnglish = isWriterLocalisation
    ? englishProgramBook
    : isSeries && isUgcUser;
  const isLocalisedNonEnglish = isWriterLocalisation
    ? nonEnglishProgramBook
    : isUserIndian;

  const exclusiveErrorToast = () => {
    toast('Sorry, you are not eligible for exclusive contract', {
      style: {
        backgroundColor: '#FFD5D3',
        color: '#710500',
      },
      closeButton: true,
    });
  };

  const handleContentAvailabilityChange = (value, setFieldValue) => {
    setIsContentAvailable(value);
    if (value) {
      setIsExclusive(false);
      setFieldValue('isExclusive', false);
      return;
    }
    setIsExclusive(true);
    setEnteredIntoAgreement(undefined);
    setFieldValue('enteredIntoAgreement', null);
    setFieldValue('isExclusive', true);
  };

  const handleEnteredIntoAgreementChange = (value, setFieldValue) => {
    setEnteredIntoAgreement(value);
    if (value) {
      setIsExclusive(false);
      setFieldValue('isExclusive', false);
      return;
    }
    setIsExclusive(true);
    setFieldValue('isExclusive', true);
  };

  const handleExclusive = (value) => {
    if (value && enteredIntoAgreement) {
      exclusiveErrorToast();
      return;
    }
    if (!value && isExclusive) {
      setShowModal(true);
      return;
    }
    setIsExclusive(value);
  };
  const handleModalChange = (value) => {
    if (value && enteredIntoAgreement) {
      exclusiveErrorToast();
      return;
    }
    setIsExclusive(value);
    setShowModal(false);
  };

  // TODO: Remove or handle before localisation
  const supportEmail = isLocalisedEnglish
    ? 'writersupport@pocketfm.com'
    : 'writers@pocketfm.com';

  const handleGuardianPhoneChange = (text) => {
    if (!text.startsWith('91')) {
      updateGuardianPhoneNo('91');
    } else {
      updateGuardianPhoneNo(text);
    }
    setGuardianPhoneErr('');
  };

  const validateGuardianPhone = () => {
    const guardianNumber = guardianPhoneNo?.slice(2);
    const authorPhoneNo = user.phone_number?.slice(3);
    if (guardianNumber === authorPhoneNo) {
      setGuardianPhoneErr(
        "Can't be the same as the creator’s registration number"
      );
      return true;
    }
    if (!/^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$/.test('+91' + guardianNumber)) {
      setGuardianPhoneErr('Required');
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (book) {
      const { uid } = getTokenAndUid();
      handlePageLoadEventLog('writer_benefit_form');
      if (isLocalisedEnglish) {
        get(`/user_api/row_creator/${uid}/?is_novel=1`).then((response) => {
          setRowData(response?.id ? response : {});
          if (response?.id) {
            const docs = extractDocuments(response.documents);
            setCancelCheque(docs[0] || {});
            setGovtUrl(docs[1] || {});
            setW9(docs[2] || {});
            setSsnOrEinUrl(docs[3] || {});
            setW8(docs[4] || {});
            setTaxIdUrl(docs[5] || {});
            setPanCardUrl(docs[6] || {});
          }
        });
      } else {
        get(`/user_api/user_bank_accounts/${uid}/?is_novel=1`).then((res) => {
          let index = res.result?.findIndex(
            (data) => data?.is_guardian_account === 1
          );
          index >= 0 && setGuardianData(res.result?.[index] || {});
          index = res.result?.findIndex((data) => !data?.is_guardian_account);
          index >= 0 && setData(res.result?.[index]);
          if (res?.result?.length <= 0 || index === -1) setData({});
        });
      }
      get(`/user_api/user_addresses/${uid}/?is_novel=1`).then((response) => {
        setAddressData(response.result[0] || {});
      });
      get('/content_api/book.novel_details', {
        params: {
          book_id: id,
          is_novel: 1,
          view: 'writers',
        },
      }).then((response) => {
        setNovelData(response.results);
      });
    }
  }, [book, isLocalisedEnglish]);

  useEffect(() => {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting)
            handleEventLog('home', 'button_view', {
              module_name:
                +getComputedStyle(saveButtonRef.current).opacity === 1
                  ? 'apply_now'
                  : 'disabled_apply_now',
              entity_id: id,
              entity_type: 'show',
            });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 1,
        }
      );
      if (saveButtonRef.current) observer.observe(saveButtonRef.current);
      return () => observer.disconnect();
    }
  }, [saveButtonRef.current]);

  return !addressData || (isLocalisedNonEnglish ? !data : !rowData) ? (
    <Loader />
  ) : (
    <Formik
      initialValues={{
        fullname: user['fullname'] || '',
        email: user['email'] || '',
        dob: '',
        contract_url: '',
        agreement_details: '',
        content_links: '',
        isContentAvailable: null,
        enteredIntoAgreement: null,
        isExclusive: null,
        guardian_email: guardianData?.guardian_email || '',
        aadhaar_card_no: data?.['aadhaar_card_no'] || '',
        aadhaar_card_url: data?.['aadhaar_card_url'] || '',
        account_name: data?.account_name || rowData?.account_name || '',
        bank_name: data?.bank_name || rowData?.bank_name || '',
        account_no: data?.account_no || rowData?.account_no || '',
        ifsc_code: data?.ifsc_code || '',
        pan_card_no: data?.pan_card_no || '',
        cancelled_cheque_url:
          data?.cancelled_cheque_url || cancelCheque?.url || '',
        pan_card_url: panCardUrl?.url || data?.pan_card_url || '',
        w8: w8Url?.url || '',
        w9: w9Url?.url || '',
        ssn_or_ein_url: ssnOrEinUrl?.url || '',
        tax_id_url: taxIdUrl?.url || '',
        address_1: addressData['address_1'] || '',
        address_2: addressData['address_2'] || '',
        pin_code: addressData['pin_code'] || '',
        city: addressData['city'] || '',
        state: addressData['state'] || '',
        country: addressData['country'] || user.location || '',
        swift_code: rowData?.swift_code || '',
        gov_id_no: rowData?.gov_id_no || '',
        govt_id_url: govtUrl?.url || '',
        book_title: novelData?.book_title || '',
        book_summary: novelData?.book_summary || '',
      }}
      enableReinitialize
      validationSchema={Yup.object({
        dob: isLocalisedEnglish && Yup.string().required('Required'),
        isContentAvailable:
          isLocalisedEnglish && Yup.boolean().required('Required'),
        content_links: isContentAvailable && Yup.string().required('Required'),
        enteredIntoAgreement:
          isContentAvailable && Yup.boolean().required('Required'),
        contract_url: enteredIntoAgreement && Yup.string().required('Required'),
        agreement_details:
          enteredIntoAgreement && Yup.string().required('Required'),
        isExclusive: isLocalisedEnglish && Yup.boolean().required('Required'),
        guardian_email:
          optionChosenAfterNameMismatch === 'add-guardian' &&
          Yup.string()
            .required('Required')
            .email('Enter valid Email ID')
            .notOneOf(
              [Yup.ref('email')],
              "Can't be the same as the author’s email id"
            ),
        aadhaar_card_no:
          optionChosenAfterNameMismatch === 'add-guardian' &&
          Yup.string()
            .required('Required')
            .matches(
              /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/,
              'Invalid Aadhaar Number'
            ),
        aadhaar_card_url:
          optionChosenAfterNameMismatch === 'add-guardian' &&
          Yup.string().required('Required'),
        book_title: Yup.string().required('Required'),
        email: Yup.string().required('Required').email('Enter valid Email ID'),
        fullname: Yup.string()
          .required('Required')
          .matches(/^[\D]*$/, 'Only Alphabets are  allowed'),
        account_name: Yup.string()
          .required('Required')
          .matches(/^[\D]*$/, 'Only Alphabets are  allowed'),
        bank_name: Yup.string().required('Required'),
        account_no: Yup.string()
          .required('Required')
          .matches(/^\d{8,18}$/, 'Please Enter Valid Account Number'),
        cancelled_cheque_url: Yup.string().required('Required'),
        address_1: Yup.string().required('Required'),
        address_2: Yup.string().required('Required'),
        pin_code: Yup.string()
          .required('Required')
          .max(12, 'PIN code length must not exceed 12 characters'),
        city: Yup.string()
          .required('Required')
          .matches(/^[a-zA-Z\s]*$/, 'Only Alphabets are  allowed'),
        state: Yup.string()
          .required('Required')
          .matches(/^[a-zA-Z\s]*$/, 'Only Alphabets are  allowed'),
        country: Yup.string().required('Required'),
        pan_card_no:
          isLocalisedNonEnglish &&
          Yup.string()
            .required('pan_card_no')
            .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid Pan Card Number'),
        swift_code:
          isLocalisedEnglish &&
          Yup.string()
            .required('swift_code')
            .matches(/^[A-Za-z0-9]{8,11}$/, 'Invalid Swift Code'),
        ifsc_code:
          isLocalisedNonEnglish &&
          Yup.string()
            .required('ifsc_code')
            .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Enter Valid IFSC code'),
        gov_id_no:
          isLocalisedEnglish &&
          Yup.string().required('Required Govt. id number'),
        pan_card_url:
          isLocalisedNonEnglish && Yup.string().required('pan_card_url'),
        w8:
          isLocalisedEnglish &&
          user.location !== 'US' &&
          Yup.string().required('w8'),
        w9:
          isLocalisedEnglish &&
          user.location === 'US' &&
          Yup.string().required('w9'),
        govt_id_url: isLocalisedEnglish && Yup.string().required('govt_id_url'),
        ssn_or_ein_url:
          isLocalisedEnglish &&
          user.location === 'US' &&
          Yup.string().required('ssn_or_ein_url'),
        tax_id_url:
          isLocalisedEnglish &&
          user.location !== 'IN' &&
          user.location !== 'US' &&
          Yup.string().required('tax_id_url'),
        book_summary: Yup.string()
          .required('Required')
          .test(
            'word_count',
            'Minimum word limit is 200 and maximum word limit is 500',
            (val) => wordCount(val) >= 200 && wordCount(val) <= 500
          ),
      })}
      onSubmit={(values, { setSubmitting }) => {
        if (
          optionChosenAfterNameMismatch === 'add-guardian' &&
          validateGuardianPhone()
        ) {
          setSubmitting(false);
          return;
        }
        if (!isAgreed) {
          setSubmitting(false);
          return;
        }
        if (
          !calculateStringMatchScore(values.fullname, values.account_name) &&
          isLocalisedNonEnglish &&
          optionChosenAfterNameMismatch !== 'add-guardian'
        ) {
          const {
            account_name,
            bank_name,
            account_no,
            ifsc_code,
            pan_card_no,
            pan_card_url,
            cancelled_cheque_url,
          } = values;
          updateAuthorBankData({
            account_name,
            bank_name,
            account_no,
            ifsc_code,
            pan_card_no,
            pan_card_url,
            cancelled_cheque_url,
          });
          setSubmitting(false);
          updateOptionChosenAfterNameMismatch('');
          toggleNameMismatchPopup(true);
          return;
        }

        handleEventLog('home', 'button_click', {
          module_name: 'apply_now',
          entity_id: id,
          entity_type: 'show',
        });
        const { uid } = getTokenAndUid();
        const {
          pan_card_url,
          cancelled_cheque_url,
          govt_id_url,
          tax_id_url,
          ssn_or_ein_url,
          w8,
          w9,
          ...formValues
        } = values;
        const formDataForProgram = {
          uid,
          entity_type: 'book',
          source: 'web',
          entity_id: id,
          book_summary: values?.book_summary,
        };

        // will never be true
        // if (!isWriterLocalisation) {
        //   formDataForProgram.program_type = isSeries
        //     ? isHindiUgcUser
        //       ? 'writer_benefit_series'
        //       : 'writer_benefit_v3_us'
        //     : 'writer_benefit_v3';
        // }
        if (isLocalisedEnglish) {
          formDataForProgram.view = 'dashboard';
          formDataForProgram.data_source = 'us-web';
          formDataForProgram.dob = values?.dob;
          formDataForProgram.content_info = isContentAvailable;
          formDataForProgram.exclusive = isExclusive;

          if (isContentAvailable) {
            formDataForProgram.content_links = values?.content_links;
            formDataForProgram.any_agreement = enteredIntoAgreement;
          }

          if (enteredIntoAgreement && isContentAvailable) {
            formDataForProgram.agreement_details = values?.agreement_details;
            formDataForProgram.contract_url = values?.contract_url;
          }
        }

        if (book.application_status === 'eligible') {
          formDataForProgram.program_id = book?.program_id;
          formDataForProgram.status = 'pending';
        }

        let formData = {};

        const {
          address_1,
          address_2,
          pin_code,
          country,
          state,
          city,
          account_name,
          account_no,
          ifsc_code,
          pan_card_no,
          bank_name,
          fullname,
          swift_code,
          gov_id_no,
          guardian_email,
          aadhaar_card_no,
          aadhaar_card_url,
        } = values;
        formData = { ...formData, account_name, account_no, bank_name };
        if (isLocalisedNonEnglish) {
          formData['pan_card_url'] = uid + '/' + pan_card_url.split('/').pop();
          formData['cancelled_cheque_url'] =
            uid + '/' + cancelled_cheque_url.split('/').pop();
          formData = {
            ...formData,
            ifsc_code,
            pan_card_no,
            account_id: data?.account_id,
            uid,
          };
        } else {
          let documents = [];
          if (w8Url?.id) {
            documents = [
              ...documents,
              {
                w8: {
                  id: w8Url?.id,
                  url: w8,
                },
              },
            ];
          } else {
            documents = [
              ...documents,
              {
                w8: { url: w8 },
              },
            ];
          }
          if (w9Url?.id) {
            documents = [
              ...documents,
              {
                w9: {
                  id: w9Url?.id,
                  url: w9,
                },
              },
            ];
          } else {
            documents = [
              ...documents,
              {
                w9: { url: w9 },
              },
            ];
          }
          if (taxIdUrl?.id) {
            documents = [
              ...documents,
              {
                tax_id_url: {
                  id: taxIdUrl?.id,
                  url: tax_id_url,
                },
              },
            ];
          } else {
            documents = [
              ...documents,
              {
                tax_id_url: { url: tax_id_url },
              },
            ];
          }
          if (ssnOrEinUrl?.id) {
            documents = [
              ...documents,
              {
                ssn_or_ein_url: {
                  id: ssnOrEinUrl?.id,
                  url: ssn_or_ein_url,
                },
              },
            ];
          } else {
            documents = [
              ...documents,
              {
                ssn_or_ein_url: { url: ssn_or_ein_url },
              },
            ];
          }
          if (cancelCheque?.id) {
            documents = [
              ...documents,
              {
                cancelled_cheque_url: {
                  id: cancelCheque?.id,
                  url: cancelled_cheque_url,
                },
              },
            ];
          } else {
            documents = [
              ...documents,
              {
                cancelled_cheque_url: { url: cancelled_cheque_url },
              },
            ];
          }
          if (panCardUrl?.id) {
            documents = [
              ...documents,
              {
                pan_card_url: {
                  id: panCardUrl?.id,
                  url: pan_card_url,
                },
              },
            ];
          } else {
            documents = [
              ...documents,
              {
                pan_card_url: { url: pan_card_url },
              },
            ];
          }

          if (govtUrl?.id) {
            documents = [
              ...documents,
              {
                govt_id_url: {
                  id: govtUrl?.id,
                  url: govt_id_url,
                },
              },
            ];
          } else {
            documents = [
              ...documents,
              {
                govt_id_url: { url: govt_id_url },
              },
            ];
          }
          formData['documents'] = documents;
          formData = { ...formData, swift_code, gov_id_no, creator_id: uid };
        }

        if (rowData?.id) {
          formData['id'] = rowData?.id;
        }
        var addressPostData = {
          uid,
          address_1,
          address_2,
          pin_code,
          state,
          city,
          address_id: addressData['address_id'],
          country,
        };
        const isStringMatched = calculateStringMatchScore(
          fullname,
          account_name
        );
        let contractData = {
          uid,
          book_id: id,
          author_name: fullname,
          phone_number: user.phone_number?.slice(3),
          email: values.email,
          book_language,
          book_name,
          address: { address_1, address_2, pin_code, state, city, country },
        };
        if (
          !isStringMatched &&
          optionChosenAfterNameMismatch !== 'add-guardian'
        ) {
          let contractFormData = {
            status: 'failed',
          };
          if (isLocalisedNonEnglish) {
            contractFormData = {
              ...contractFormData,
              reason:
                'Author name and account name is not matched and score is less than 50%',
            };
          }
          contractData = { ...contractData, ...contractFormData };
        }
        if (optionChosenAfterNameMismatch === 'add-guardian') {
          contractData['account_details'] = { aadhaar_card_no };
          contractData['guardian_account_details'] = {
            guardian_email,
            account_name,
            account_no,
            ifsc_code,
            pan_card_no,
            bank_name,
            guardian_phone_number: guardianPhoneNo?.slice(2) || '',
          };
        } else {
          contractData['account_details'] = {
            account_name,
            account_no,
            ifsc_code,
            pan_card_no,
            bank_name,
          };
        }

        if (optionChosenAfterNameMismatch === 'add-guardian') {
          delete formData.account_id;
          formData['is_guardian_account'] = 1;
          formDataForProgram['is_guardian_flow'] = 1;
          formData['guardian_phone_number'] = '+91' + guardianPhoneNo?.slice(2);
          formData['guardian_email'] = values?.guardian_email;
          contractData['is_guardian_flow'] = 1;
          contractData['status'] = 'undertaker_pending';
          if (guardianData?.account_id) {
            formData['account_id'] = guardianData?.account_id;
          }
        } else {
          formData['is_guardian_account'] = 0;
        }
        let aadharData = {};
        if (optionChosenAfterNameMismatch === 'add-guardian') {
          aadharData = {
            aadhaar_card_no,
            aadhaar_card_url,
            uid,
            ...authorBankData,
          };
          if (data?.account_id) {
            aadharData['account_id'] = data?.account_id;
          }
        }
        const allPromises = [
          isLocalisedNonEnglish
            ? post('/user_api/user_bank_accounts/?is_novel=1', {
                data: formData,
              }).catch((error) => ({ error }))
            : post(
                `/user_api/row_creator/?is_novel=${novelData?.is_novel || 1}`,
                { data: formData }
              ).catch((error) => ({ error })),
          optionChosenAfterNameMismatch === 'add-guardian' &&
            post(
              `/user_api/user_bank_accounts/?is_novel=${novelData?.is_novel || 1}`,
              { data: { ...aadharData } }
            ).catch((error) => ({ error })),
          post(`/user_api/user.update?is_novel=${novelData?.is_novel || 1}`, {
            data: {
              fullname: values['fullname'],
              email: values['email'],
              user_id: uid,
            },
          }).catch((error) => ({ error })),
          post(
            `/user_api/user_addresses/?is_novel=${novelData?.is_novel || 1}`,
            { data: { ...addressPostData } }
          ).catch((error) => ({ error })),
        ];
        if (
          (wbpInvite || book?.wbp_sequence_variant === 'B') &&
          optionChosenAfterNameMismatch !== 'add-guardian'
        ) {
          contractData['status'] = 'contract_generated';
        }
        Promise.all(allPromises)
          .then(async (results) => {
            try {
              if (results.length > 0 && results[0]?.result?.id) {
                // to handle case where one api fails and rowData id is not updated to send in next call
                setRowData({ ...rowData, id: results[0].result.id });
              }
              const failedResults = results.filter((result) => result?.error);
              if (failedResults.length > 0) {
                const { error } = failedResults[0];
                toggleApiError({
                  show: true,
                  title: 'Invalid Information',
                  message: error?.message,
                });
                setSubmitting(false);
                return;
              }
              if (isLocalisedNonEnglish) {
                const contractApi =
                  (wbpInvite || book?.wbp_sequence_variant === 'B') &&
                  optionChosenAfterNameMismatch !== 'add-guardian'
                    ? '/contract/wbp_contract/create_wbp_contract/?is_novel=1'
                    : '/contract/?is_novel=1';
                await post(contractApi, {
                  data: { ...contractData },
                });
              }
              await post(
                `/content_api/book.creator_ben_prog/?is_novel=${novelData?.is_novel || 1}`,
                { data: { ...formDataForProgram } }
              );
              if (isNovelContract) {
                if (
                  book?.wbp_sequence_variant === 'B' &&
                  optionChosenAfterNameMismatch !== 'add-guardian'
                ) {
                  handleGenerateContract();
                } else {
                  handleContractDetails(fullname);
                }
              } else {
                if (
                  book?.wbp_sequence_variant === 'B' &&
                  optionChosenAfterNameMismatch !== 'add-guardian'
                ) {
                  setCurrentStep(3);
                } else if (book?.wbp_v3_eligiblity?.hindi_contract_rvp) {
                  resetSteps();
                } else {
                  setCurrentStep(2);
                }
              }
              setSubmitting(false);
              handleFlutterCallbacks({
                method: 'formSubmissionCompletion',
                data: {},
                elseDoThis: () => {},
              });
            } catch (err) {
              setSubmitting(false);
              toggleApiError({
                show: true,
                title: 'Something went wrong',
                message: (
                  <>
                    Something went wrong with this application,{' '}
                    <a href={`mailto:${supportEmail}`}>
                      contact Us for more details.
                    </a>
                  </>
                ),
              });
            }
          })
          .catch((error) => {
            setSubmitting(false);
            toggleApiError({
              show: true,
              title: 'Something went wrong',
              message: error.message,
            });
            throw error;
          });
      }}
    >
      {({
        isValid,
        isSubmitting,
        touched,
        submitCount,
        setFieldValue,
        errors,
        values,
        validateField,
        setErrors,
        setFieldTouched,
      }) => {
        return (
          <>
            <GenericErrorPopup
              show={apiError.show}
              onClose={() => toggleApiError(false)}
              title={apiError.title}
              message={apiError.message}
            />
            <Form>
              <Container>
                <SectionHeading>
                  Application for Writer Benefit Program
                </SectionHeading>
                <HelpText>
                  You will be eligible for bonuses and receive monthly payments
                  in your bank account once you sign a contract with us
                </HelpText>
                <FlexContainer>
                  <Box width={['100%', '49%']} mb={8}>
                    <FloatingInput
                      type="text"
                      name="fullname"
                      label="Author Name"
                      size="lg"
                      autoFocus
                      hasError={submitCount > 0 && errors?.fullname}
                      touched={touched?.fullname}
                      onFocus={() =>
                        setFocusFields({ ...focusFields, fullname: true })
                      }
                      onBlur={() =>
                        setFocusFields({ ...focusFields, fullname: false })
                      }
                    />
                    {focusFields?.fullname && (
                      <InvalidDetailsDiv value="blue">
                        Please confirm your real name for contract
                      </InvalidDetailsDiv>
                    )}
                    {errors?.fullname && (
                      <InvalidDetailsDiv value="red">
                        {errors.fullname}
                      </InvalidDetailsDiv>
                    )}
                  </Box>
                  <Box width={['100%', '49%']} mb={8}>
                    <FloatingInput
                      type="text"
                      name="email"
                      label="Email ID"
                      size="lg"
                      readOnly={user?.login_type === 'email_login'}
                      onFocus={() =>
                        setFocusFields({ ...focusFields, email: true })
                      }
                      onBlur={() =>
                        setFocusFields({ ...focusFields, email: true })
                      }
                    />
                    {focusFields?.email && (
                      <InvalidDetailsDiv value="blue">
                        Please fill valid/existing email for contract
                      </InvalidDetailsDiv>
                    )}
                    {errors?.email && (
                      <InvalidDetailsDiv value="red">
                        {errors.email}
                      </InvalidDetailsDiv>
                    )}
                  </Box>
                </FlexContainer>
                {isLocalisedEnglish && (
                  <>
                    <Box width={['100%', '49%']} mb={8}>
                      <DateOfBirth>
                        <label>Date of birth</label>
                        <DoB
                          type="date"
                          value={dob}
                          onChange={(e) => {
                            setFieldValue('dob', e.target.value);
                            setDoB(e.target.value);
                          }}
                          placeholder="Date of birth"
                          max={new Date().toISOString().split('T')[0]}
                        />
                      </DateOfBirth>
                      {errors?.dob && (
                        <InvalidDetailsDiv value="red">
                          {errors.dob}
                        </InvalidDetailsDiv>
                      )}
                    </Box>

                    <RadioSelect
                      label="Is this content available on any other writing platform ?"
                      options={booleanOptions}
                      fieldName="isContentAvailable"
                      value={isContentAvailable}
                      onChange={(val) => {
                        handleContentAvailabilityChange(val, setFieldValue);
                      }}
                      allowMultiple={false}
                      error={errors?.isContentAvailable}
                    />
                  </>
                )}
                {isContentAvailable && (
                  <>
                    <SubSectionTitle>
                      Please share link to the content posted in other writing
                      platform
                    </SubSectionTitle>
                    <Input
                      type="text"
                      name="content_links"
                      placeholder="Separate by commas if multiple links"
                      size="lg"
                      hasError={errors?.content_links}
                    />
                    {isContentAvailable && errors?.content_links && (
                      <InvalidDetailsDiv value="red">
                        {errors?.content_links}
                      </InvalidDetailsDiv>
                    )}
                  </>
                )}
                {isContentAvailable && (
                  <Box>
                    <RadioSelect
                      label="Have you entered into any agreement for the content ?"
                      options={booleanOptions}
                      fieldName="enteredIntoAgreement"
                      value={enteredIntoAgreement}
                      onChange={(val) => {
                        handleEnteredIntoAgreementChange(val, setFieldValue);
                      }}
                      allowMultiple={false}
                      error={errors?.enteredIntoAgreement}
                    />
                  </Box>
                )}

                {enteredIntoAgreement && (
                  <>
                    <SubSectionTitle>
                      Please share details of the agreement
                    </SubSectionTitle>
                    <Input
                      type="text"
                      name="agreement_details"
                      placeholder="Eg : Exclusive contract from Wattpad"
                      size="lg"
                      error={errors?.agreement_details}
                    />

                    <Box my={16}>
                      <SubSectionTitle>
                        Please upload your Contract
                      </SubSectionTitle>
                      <InputContainer>
                        <Upload
                          name="contract_url"
                          privateDownload
                          hasError={submitCount > 0 && errors['contract_url']}
                          hideInputOnValue
                          showProgress
                          saveWithoutCDN={1}
                          cloud_dir_file={getTokenAndUid().uid}
                          placeholder="Drop your doc file here to upload or click to select"
                          renderComp={FileUploadComponent}
                          fileTypeTags="user_doc"
                          accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/doc, application/ms-doc, application/pdf"
                          extraParams={{
                            title: 'Contract',
                          }}
                        />
                      </InputContainer>
                      <ExtraNote>
                        <b>Please note:</b> File should be in PDF/ Doc format &
                        Less than 20 MB
                      </ExtraNote>
                    </Box>
                  </>
                )}
                {(isContentAvailable === false ||
                  enteredIntoAgreement !== undefined) && (
                  <Box>
                    <RadioSelect
                      fieldName="isExclusive"
                      label="Which contract would you like to sign with us ?"
                      options={contractTypeOptions}
                      value={isExclusive}
                      onChange={handleExclusive}
                      allowMultiple={false}
                    />

                    <ExtraNote>
                      <b>Please note:</b> If you are signing an exclusive
                      contract with us, you will be requested to remove content
                      from other platforms, but you earn more!
                      <InfoIcon
                        style={{ marginLeft: '4px' }}
                        onClick={() => {
                          setInfoActive(true);
                          setShowModal(true);
                        }}
                      />{' '}
                    </ExtraNote>
                  </Box>
                )}

                <Popup show={showModal} close={() => setShowModal(true)}>
                  <>
                    <RightCrossIcon
                      onClick={() => {
                        setInfoActive(false);
                        setShowModal(false);
                      }}
                    />
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      {!infoActive && (
                        <Text variant="heading" mt={20}>
                          Are You Sure ?
                        </Text>
                      )}
                    </Box>
                    <Box display="flex" justifyContent="center">
                      <Text textAlign="center" variant="body">
                        Maximize your benefits with exclusive contract
                      </Text>
                    </Box>
                    <Box my={10} display="flex" justifyContent="center">
                      <img
                        src="/images/exclusive_contract_features_1.svg"
                        alt="exclusive-features"
                      />
                    </Box>
                    {!infoActive && (
                      <RadioSelect
                        fieldName="isExclusive"
                        options={[
                          { name: true, label: 'Go with Exclusive' },
                          {
                            name: false,
                            label: 'Continue with Non-Exclusive',
                          },
                        ]}
                        value={isExclusive}
                        onChange={handleModalChange}
                        allowMultiple={false}
                        direction="column"
                      />
                    )}
                  </>
                </Popup>

                {optionChosenAfterNameMismatch === 'add-guardian' && (
                  <FlexContainer>
                    <Box width={['100%', '49%']} mb={8}>
                      <FloatingInput
                        type="text"
                        name="aadhaar_card_no"
                        label="Aadhar Number"
                        size="lg"
                        hasError={submitCount > 0 && errors?.aadhaar_card_no}
                      />
                      {errors?.aadhaar_card_no && (
                        <InvalidDetailsDiv value="red">
                          {errors.aadhaar_card_no}
                        </InvalidDetailsDiv>
                      )}
                    </Box>
                    <InputContainer>
                      <UploadLabel>Aadhaar Card Document</UploadLabel>
                      <Upload
                        name="aadhaar_card_url"
                        privateDownload
                        hasError={submitCount > 0 && errors['aadhaar_card_url']}
                        hideInputOnValue
                        showProgress
                        saveWithoutCDN={1}
                        cloud_dir_file={getTokenAndUid().uid}
                        placeholder="Drop your doc file here to upload or click to select"
                        renderComp={FileUploadComponent}
                        fileTypeTags="user_doc"
                        accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/doc, application/ms-doc, image/jpeg, image/jpg, image/png, application/pdf"
                        extraParams={{
                          title: 'Bank-Document',
                        }}
                      />
                    </InputContainer>
                  </FlexContainer>
                )}
                <Box my={16}>
                  <SubSectionTitle>Mailing address</SubSectionTitle>
                  <Box variant="flex" flexDirection={['column', 'row']}>
                    <Box width={['100%', '49%']} mb={16}>
                      <FloatingInput
                        type="text"
                        name="address_1"
                        label="Apartment/ house/ building number"
                        size="lg"
                        hasError={submitCount > 0 && errors['address_1']}
                      />
                      {errors.address_1 && (
                        <InvalidDetailsDiv value="red">
                          {errors.address_1}
                        </InvalidDetailsDiv>
                      )}
                    </Box>

                    <Box width={['100%', '49%']} mb={16}>
                      <FloatingInput
                        type="text"
                        name="address_2"
                        label="Street or area name"
                        size="lg"
                        hasError={submitCount > 0 && errors['address_2']}
                      />
                      {errors.address_2 && (
                        <InvalidDetailsDiv value="red">
                          {errors.address_2}
                        </InvalidDetailsDiv>
                      )}
                    </Box>
                  </Box>
                  <Box variant="flex" flexDirection={['column', 'row']}>
                    <Box width={['100%', '49%']} mb={16}>
                      <FloatingInput
                        type="text"
                        name="pin_code"
                        label="Pincode/ zipcode/ postal code"
                        size="lg"
                        hasError={submitCount > 0 && errors['pin_code']}
                      />
                      {errors.pin_code && (
                        <InvalidDetailsDiv value="red">
                          {errors.pin_code || "Field Can't be empty"}
                        </InvalidDetailsDiv>
                      )}
                    </Box>
                    <Box width={['100%', '49%']} mb={16}>
                      <FloatingInput
                        type="text"
                        name="city"
                        label="City"
                        size="lg"
                        hasError={submitCount > 0 && errors['city']}
                      />
                      {errors.city && (
                        <InvalidDetailsDiv value="red">
                          {errors.city}
                        </InvalidDetailsDiv>
                      )}
                    </Box>
                  </Box>
                  <Box variant="flex" flexDirection={['column', 'row']}>
                    <Box width={['100%', '49%']} mb={16}>
                      <FloatingInput
                        type="text"
                        name="state"
                        label="State/ Province"
                        size="lg"
                        hasError={submitCount > 0 && errors['state']}
                      />
                      {errors.state && (
                        <InvalidDetailsDiv value="red">
                          {errors.state}
                        </InvalidDetailsDiv>
                      )}
                    </Box>
                    {user.location !== 'US' && (
                      <Box width={['100%', '49%']} mb={16}>
                        <DropDownSelect
                          name="country"
                          placeholder="Country"
                          selectOptions={countryList.filter(
                            (country) => country.name !== 'Global'
                          )}
                          idKey="code"
                          nameKey="name"
                          readOnly
                        />
                        {errors.country && (
                          <InvalidDetailsDiv value="red">
                            {errors.country}
                          </InvalidDetailsDiv>
                        )}
                      </Box>
                    )}
                  </Box>
                </Box>
                <SubSectionTitle>
                  {optionChosenAfterNameMismatch === 'add-guardian'
                    ? 'Your Guardian’s Bank details'
                    : 'Bank details'}
                </SubSectionTitle>
                <InlineInfoText>
                  This is the bank account in which you will recieve your
                  payments
                </InlineInfoText>
                {optionChosenAfterNameMismatch === 'add-guardian' && (
                  <FlexContainer>
                    <Box width={['100%', '49%']} mb={8}>
                      <FloatingInput
                        type="text"
                        name="guardian_email"
                        label="Guardian Email ID"
                        size="lg"
                        hasError={submitCount > 0 && errors['pin_code']}
                        readOnly={user?.login_type === 'email_login'}
                        onFocus={() =>
                          setFocusFields({
                            ...focusFields,
                            guardian_email: true,
                          })
                        }
                        onBlur={() =>
                          setFocusFields({
                            ...focusFields,
                            guardian_email: true,
                          })
                        }
                      />
                      {errors?.guardian_email && (
                        <InvalidDetailsDiv value="red">
                          {errors.guardian_email}
                        </InvalidDetailsDiv>
                      )}
                    </Box>
                    <Box width={['100%', '49%']} mb={8}>
                      <PhoneInput
                        error={guardianPhoneErr}
                        name="guardian_phone_no"
                        disableDropdown
                        onlyCountries={['in']}
                        country={'in'}
                        type="text"
                        value={guardianPhoneNo}
                        onChange={(text) => handleGuardianPhoneChange(text)}
                      />
                      {guardianPhoneErr !== '' && (
                        <InvalidDetailsDiv value="red">
                          {guardianPhoneErr ||
                            "Can't be the same as the creator’s registration number"}
                        </InvalidDetailsDiv>
                      )}
                    </Box>
                  </FlexContainer>
                )}
                <FlexContainer>
                  <Box width={['100%', '49%']} mb={16}>
                    <FloatingInput
                      type="text"
                      name="account_name"
                      label="Full Name ( Account owner )"
                      size="lg"
                      hasError={errors?.account_name}
                      touched={touched?.account_name}
                      autoFocus={optionChosenAfterNameMismatch === 'edit-names'}
                      onFocus={() =>
                        setFocusFields({ ...focusFields, account_name: true })
                      }
                      onBlur={() =>
                        setFocusFields({
                          ...focusFields,
                          account_name: false,
                        })
                      }
                    />

                    {focusFields?.account_name &&
                      optionChosenAfterNameMismatch !== 'add-guardian' && (
                        <InvalidDetailsDiv value="blue">
                          Please enter the exact name as registered with bank
                        </InvalidDetailsDiv>
                      )}
                    {errors.account_name && (
                      <InvalidDetailsDiv value="red">
                        {errors.account_name}
                      </InvalidDetailsDiv>
                    )}
                  </Box>

                  <Box width={['100%', '49%']} mb={16}>
                    <FloatingInput
                      type="text"
                      name="bank_name"
                      label="Bank name"
                      size="lg"
                      hasError={submitCount > 0 && errors['bank_name']}
                    />
                    {errors.bank_name && (
                      <InvalidDetailsDiv value="red">
                        {errors.bank_name}
                      </InvalidDetailsDiv>
                    )}
                  </Box>
                </FlexContainer>

                <FlexContainer>
                  <Box width={['100%', '49%']} mb={16}>
                    <FloatingInput
                      type="text"
                      name="account_no"
                      label="Account number"
                      size="lg"
                      onFocus={() =>
                        setFocusFields({ ...focusFields, account_no: true })
                      }
                      onBlur={() =>
                        setFocusFields({ ...focusFields, account_no: false })
                      }
                    />
                    {focusFields?.account_no && (
                      <InvalidDetailsDiv value="blue">
                        Enter the same account number as in Bank Proof Document
                      </InvalidDetailsDiv>
                    )}
                    {errors?.account_no && (
                      <InvalidDetailsDiv value="red">
                        {errors.account_no}
                      </InvalidDetailsDiv>
                    )}
                  </Box>
                  {isLocalisedNonEnglish ? (
                    <Box width={['100%', '49%']} mb={16}>
                      <FloatingInput
                        type="text"
                        name="ifsc_code"
                        label="IFSC"
                        size="lg"
                      />
                      {errors?.ifsc_code && (
                        <InvalidDetailsDiv value="red">
                          {errors.ifsc_code}
                        </InvalidDetailsDiv>
                      )}
                    </Box>
                  ) : (
                    <Box width={['100%', '49%']} mb={16}>
                      <FloatingInput
                        type="text"
                        name="swift_code"
                        label="SWIFT code"
                        size="lg"
                      />
                      {errors?.swift_code && (
                        <InvalidDetailsDiv value="red">
                          {errors.swift_code}
                        </InvalidDetailsDiv>
                      )}
                    </Box>
                  )}
                </FlexContainer>
                {isLocalisedNonEnglish ? (
                  <Box variant="flex" flexDirection={['column', 'row']}>
                    <Box width={['100%', '49%']} mb={16}>
                      <FloatingInput
                        type="text"
                        name="pan_card_no"
                        label="PAN card number"
                        size="lg"
                        hasError={submitCount > 0 && errors['pan_card_no']}
                      />
                      {errors.pan_card_no && (
                        <InvalidDetailsDiv value="red">
                          {errors.pan_card_no}
                        </InvalidDetailsDiv>
                      )}
                    </Box>
                  </Box>
                ) : (
                  <Box variant="flex" flexDirection={['column', 'row']}>
                    <Box width={['100%', '49%']} mb={16}>
                      <FloatingInput
                        type="text"
                        name="gov_id_no"
                        label="Govt. issued identification card number"
                        size="lg"
                        hasError={submitCount > 0 && errors['gov_id_no']}
                      />
                      {errors.gov_id_no && (
                        <InvalidDetailsDiv value="red">
                          {errors.gov_id_no}
                        </InvalidDetailsDiv>
                      )}
                    </Box>
                  </Box>
                )}

                <SubSectionTitle>
                  {optionChosenAfterNameMismatch === 'add-guardian'
                    ? "Guardian's Documents"
                    : 'Documents'}
                </SubSectionTitle>
                <InlineInfoText>
                  These documents are required to verify the bank details and
                  for tax purposes
                </InlineInfoText>
                <FlexContainer>
                  <InputContainer>
                    <Upload
                      // label="Cancelled Cheqeue"
                      label="Cancelled cheque/ Passbook/Bank statement"
                      name="cancelled_cheque_url"
                      privateDownload
                      hasError={
                        submitCount > 0 && errors['cancelled_cheque_url']
                      }
                      hideInputOnValue
                      showProgress
                      saveWithoutCDN={1}
                      cloud_dir_file={getTokenAndUid().uid}
                      placeholder="Drop your doc file here to upload or click to select"
                      renderComp={FileUploadComponent}
                      fileTypeTags="user_doc"
                      accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/doc, application/ms-doc, image/jpeg, image/jpg, image/png, application/pdf"
                      extraParams={{
                        title: 'Bank-Document',
                      }}
                      extraNote="Submit your banking proof:Cancelled Cheque/ Passbook/Bank statement to confirm your bank
                    details"
                    />
                  </InputContainer>

                  {isLocalisedNonEnglish ? (
                    <InputContainer>
                      <Upload
                        name="pan_card_url"
                        label="PAN Card"
                        privateDownload
                        hasError={submitCount > 0 && errors['pan_card_url']}
                        hideInputOnValue
                        showProgress
                        saveWithoutCDN={1}
                        cloud_dir_file={getTokenAndUid().uid}
                        placeholder="Drop your doc file here to upload or click to select"
                        renderComp={FileUploadComponent}
                        fileTypeTags="user_doc"
                        accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/doc, application/ms-doc, image/jpeg, image/jpg, image/png, application/pdf"
                        extraParams={{
                          title: 'PAN Card',
                        }}
                        extraNote="Pan card is required for tax purposes, if you do not provide the pan card, 20% tax will be
                      deducted"
                      />
                    </InputContainer>
                  ) : (
                    <InputContainer>
                      <Upload
                        name="govt_id_url"
                        label="Govt. issued identification card"
                        privateDownload
                        hasError={submitCount > 0 && errors['govt_id_url']}
                        hideInputOnValue
                        showProgress
                        saveWithoutCDN={1}
                        cloud_dir_file={getTokenAndUid().uid}
                        placeholder="Drop your doc file here to upload or click to select"
                        renderComp={FileUploadComponent}
                        fileTypeTags="user_doc"
                        accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/doc, application/ms-doc, image/jpeg, image/jpg, image/png, application/pdf"
                        extraParams={{
                          title: 'Govt. ID',
                        }}
                        extraNote="This info. is required for tax and verification purposes"
                      />
                    </InputContainer>
                  )}
                </FlexContainer>

                {isLocalisedEnglish && (
                  <FlexContainer>
                    <InputContainer>
                      {user?.location === 'US' ? (
                        <Upload
                          label="W9"
                          name="w9"
                          privateDownload
                          hideInputOnValue
                          cloud_dir_file={getTokenAndUid().uid}
                          saveWithoutCDN={1}
                          showProgress
                          sampleFileUrl="https://d10oek268g8t1f.cloudfront.net/fw9.pdf"
                          placeholder="Drop your doc file here to upload or click to select"
                          renderComp={FileUploadComponent}
                          fileTypeTags="user_doc"
                          accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/doc, application/ms-doc, image/jpeg, image/jpg, image/png, application/pdf"
                          extraParams={{
                            title: 'W9 Self Declaration',
                          }}
                          hasError={errors.w9}
                          extraNote="Self declare the document by downloading template"
                        />
                      ) : (
                        <Upload
                          label="W8"
                          name="w8"
                          privateDownload
                          hideInputOnValue
                          cloud_dir_file={getTokenAndUid().uid}
                          saveWithoutCDN={1}
                          showProgress
                          sampleFileUrl="https://d10oek268g8t1f.cloudfront.net/20113bf88f06ec4aad5264c55dd760579dc62e24.pdf"
                          placeholder="Drop your doc file here to upload or click to select"
                          renderComp={FileUploadComponent}
                          fileTypeTags="user_doc"
                          accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/doc, application/ms-doc, image/jpeg, image/jpg, image/png, application/pdf"
                          extraParams={{
                            title: 'W8 Self Declaration',
                          }}
                          hasError={errors.w8}
                          extraNote="Self Declare the document by downloading template"
                        />
                      )}
                    </InputContainer>
                    <InputContainer>
                      {user?.location === 'US' ? (
                        <Upload
                          label="Tax proof documents"
                          name="ssn_or_ein_url"
                          privateDownload
                          hideInputOnValue
                          cloud_dir_file={getTokenAndUid().uid}
                          saveWithoutCDN={1}
                          showProgress
                          placeholder="Drop your doc file here to upload or click to select"
                          renderComp={FileUploadComponent}
                          fileTypeTags="user_doc"
                          accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/doc, application/ms-doc, image/jpeg, image/jpg, image/png, application/pdf"
                          extraParams={{
                            title: 'Tax proof documents',
                          }}
                          hasError={errors.ssn_or_ein_url}
                          extraNote="Please upload SSN / EIN as mentioned in W9"
                        />
                      ) : user?.location === 'IN' ? (
                        <Upload
                          name="pan_card_url"
                          label="Tax proof documents"
                          privateDownload
                          hasError={submitCount > 0 && errors['pan_card_url']}
                          hideInputOnValue
                          showProgress
                          saveWithoutCDN={1}
                          cloud_dir_file={getTokenAndUid().uid}
                          placeholder="Drop your doc file here to upload or click to select"
                          renderComp={FileUploadComponent}
                          fileTypeTags="user_doc"
                          accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/doc, application/ms-doc, image/jpeg, image/jpg, image/png, application/pdf"
                          extraParams={{
                            title: 'Pan Card',
                          }}
                          extraNote="PAN Card as mentioned in W8"
                        />
                      ) : (
                        <Upload
                          label="Tax proof documents"
                          name="tax_id_url"
                          privateDownload
                          hideInputOnValue
                          cloud_dir_file={getTokenAndUid().uid}
                          saveWithoutCDN={1}
                          showProgress
                          placeholder="Drop your doc file here to upload or click to select"
                          renderComp={FileUploadComponent}
                          fileTypeTags="user_doc"
                          accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/doc, application/ms-doc, image/jpeg, image/jpg, image/png, application/pdf"
                          extraParams={{
                            title: 'Tax proof documents',
                          }}
                          hasError={errors.tax_id_url}
                          extraNote="Tax Identification Number as mentioned in W8"
                        />
                      )}
                    </InputContainer>
                  </FlexContainer>
                )}
                <Box mt={20}>
                  <SubSectionTitle>Book information</SubSectionTitle>
                  <InlineInfoText>
                    Book info. for which you are submitting this application
                  </InlineInfoText>
                </Box>
                <FlexContainer>
                  <Box width={['100%', '49%']} mb={8}>
                    <FloatingInput
                      type="text"
                      name="book_title"
                      label=" "
                      size="lg"
                      readOnly
                    />
                    {errors?.book_title && (
                      <InvalidDetailsDiv value="red">
                        {errors.book_title}
                      </InvalidDetailsDiv>
                    )}
                  </Box>
                </FlexContainer>
                <Box width={['100%', '100%']} mb={8}>
                  <Input
                    type="text"
                    name="book_summary"
                    label="Summary of the story"
                    infoTitle="Describe the story in at least 200 words"
                    size="lg"
                    asTextArea
                    placeholder="Describe the story in at least 200 words"
                    hasError={errors?.book_summary}
                  />
                  {errors?.book_summary && (
                    <InvalidDetailsDiv value="red">
                      {errors.book_summary}
                    </InvalidDetailsDiv>
                  )}
                  {book_language === 'hindi' && (
                    <CheckSampleBtn
                      onClick={() => {
                        setShowSampleData(true);
                        setSampleData({
                          heading: 'Sample Story Summary',
                          url: 'https://radiolycontent.s3.ap-southeast-1.amazonaws.com/books/writers/a2a0a875414049474f9f56ea808b8bc5b0ae1bb2.pdf',
                        });
                      }}
                    >
                      Check sample summary{' '}
                      <DownloadWithoutCircle width="12" height="12" />
                    </CheckSampleBtn>
                  )}
                  {showSampleData && (
                    <DataModal
                      onClose={() => {
                        setShowSampleData(false);
                        setSampleData({ url: '', heading: '' });
                      }}
                      url={sampleData?.url}
                      heading={sampleData?.heading}
                    />
                  )}
                </Box>
                <HR />
                <ConfirmAndSubmit>
                  <AgreeCTA active={isAgreed}>
                    <RadioIcon
                      active={isAgreed}
                      onClick={() => setIsAgreed(!isAgreed)}
                    >
                      <CheckedIcon />
                    </RadioIcon>
                    <span>
                      I agree to the{' '}
                      <span
                        onClick={() =>
                          isLocalisedEnglish
                            ? handleNotionOrExternalLink(
                                'https://pocketnovel.notion.site/pocketnovel/Pocket-Novel-Content-and-Community-Guidelines-2cc85c9d716747e2b0d103e3d5a3b07a'
                              )
                            : showTerms()
                        }
                      >
                        terms and conditions
                      </span>{' '}
                      and confirm that this is my original work
                    </span>
                  </AgreeCTA>
                  {!isSubmitting && (
                    <SaveButton
                      ref={saveButtonRef}
                      type="submit"
                      isValid={isValid && isAgreed}
                    >
                      {book?.wbp_sequence_variant === 'B'
                        ? 'Generate Contract'
                        : 'Submit Application'}
                    </SaveButton>
                  )}
                  {isSubmitting && (
                    <SaveButton type="button" isValid={isValid && isAgreed}>
                      <Loader invertColor inline size="sm" />
                    </SaveButton>
                  )}
                </ConfirmAndSubmit>
              </Container>

              <Popup
                show={nameMismatchPopup}
                close={() => {
                  updateOptionChosenAfterNameMismatch('');
                  toggleNameMismatchPopup(false);
                }}
                renderActions={
                  <SaveBtn
                    isValid={optionChosenAfterNameMismatch !== ''}
                    onClick={() => {
                      window.scrollTo(0, 0);
                      if (optionChosenAfterNameMismatch === 'edit-names') {
                        setFieldValue('account_name', '', false);
                        setFieldValue('fullname', '', false);
                        setErrors({
                          account_name:
                            'Author Name & Bank Account holder’s Name should to be the same.',
                          fullname:
                            'Author Name & Bank Account holder’s Name should to be the same.',
                        });
                      } else {
                        setFieldValue(
                          'account_name',
                          guardianData?.account_name || '',
                          false
                        );
                        setFieldValue(
                          'bank_name',
                          guardianData?.bank_name || '',
                          false
                        );
                        setFieldValue(
                          'account_no',
                          guardianData?.account_no || '',
                          false
                        );
                        setFieldValue(
                          'ifsc_code',
                          guardianData?.ifsc_code || '',
                          false
                        );
                        setFieldValue(
                          'pan_card_no',
                          guardianData?.pan_card_no || '',
                          false
                        );
                        setFieldValue(
                          'pan_card_url',
                          guardianData?.pan_card_url || '',
                          false
                        );
                        setFieldValue(
                          'cancelled_cheque_url',
                          guardianData?.cancelled_cheque_url || '',
                          false
                        );
                        updateGuardianPhoneNo(
                          guardianData?.guardian_phone_number?.slice(1) || ''
                        );
                        !guardianData?.guardian_phone_number &&
                          setGuardianPhoneErr('Required');
                      }
                      toggleNameMismatchPopup(false);
                    }}
                  >
                    Submit
                  </SaveBtn>
                }
              >
                <>
                  <RightCrossIcon
                    onClick={() => {
                      updateOptionChosenAfterNameMismatch('');
                      toggleNameMismatchPopup(false);
                    }}
                  />
                  <Box display="flex" alignItems="center">
                    <Exclamation color="red" />
                    <Text variant="title" ml={8}>
                      Bank Details and Author Info mismatched
                    </Text>
                  </Box>
                  <Box my={16} ml={16}>
                    <Box display="flex" alignItems="center">
                      <CheckBox
                        active={optionChosenAfterNameMismatch === 'edit-names'}
                        onClick={() =>
                          updateOptionChosenAfterNameMismatch('edit-names')
                        }
                      >
                        <CheckedIcon />
                      </CheckBox>
                      <Text variant="subHeading" ml={8}>
                        I have my own bank and pan detail, I will correct the
                        submitted detail.
                      </Text>
                    </Box>
                    <Box display="flex" alignItems="center" mt={8}>
                      <CheckBox
                        active={
                          optionChosenAfterNameMismatch === 'add-guardian'
                        }
                        onClick={() =>
                          updateOptionChosenAfterNameMismatch('add-guardian')
                        }
                      >
                        <CheckedIcon />
                      </CheckBox>
                      <Text variant="subHeading" ml={8}>
                        I don’t have Bank and Pan info, Please consider my
                        guardian’s info
                      </Text>
                    </Box>
                  </Box>
                </>
              </Popup>
            </Form>
          </>
        );
      }}
    </Formik>
  );
};

export default WbpForm;
